import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import PermissionForm from "components/Permissions/form";
import { addPermission, getAllModules, selectModules, selectPermissionsStatus } from "redux/slices/permissionsSlice";

const currentAction = "ADD";
const AddPermission = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const modules = useSelector(selectModules);
  const loading = useSelector(selectPermissionsStatus);
  useEffect(() => {
    if (!loading) {
      dispatch(getAllModules());
    }
  }, [dispatch]);

  const onSubmit = async (payload) => {
    await dispatch(addPermission(payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.permissions) : ""
    );
  };

  return (
    <>
      <Navbar />
      <LightLayout doublebar>
        <PermissionForm action={currentAction} onSubmit={onSubmit} modules={modules} />
      </LightLayout>
    </>
  );
};

export default AddPermission;
